module.exports = __webpack_public_path__ + "static/media/bg-card-pass.c02297ac.png";